var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDebit = function SvgDebit(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E02020",
    opacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M18.733 18.015l2.658 1.473c.163.09.367.032.456-.129.032-.058.046-.125.04-.192l-.864-8.863c-.018-.184-.183-.32-.367-.304-.042.004-.083.015-.12.034l-7.975 3.964c-.165.083-.23.284-.146.449.03.06.078.109.137.142l2.643 1.464c-2.031 3.21-7.144 4.383-7.953 3.977l-.017-.01c-.163-.086-.364-.028-.452.131-.09.161-.03.365.133.455l.015.008c3.295 1.75 9.14 1.781 11.812-2.6z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDebit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/debit.4c6b58f2.svg";
export { ForwardRef as ReactComponent };